// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"920":"e20ea2ac","7102":"ea7c6b01"}[chunkId] + ".chunk.css";
};